var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHighlightBillTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51 24.98a2.49 2.49 0 01-2.49 2.49h16.47a2 2 0 002-2v-2H9.51v1.51z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.22 2.59a.492.492 0 00-.51.02l-2.72 1.81-2.72-1.81a.5.5 0 00-.55 0L14 4.42l-2.72-1.81a.5.5 0 00-.55 0L8.01 4.42 5.3 2.61a.493.493 0 00-.51-.02c-.17.08-.27.25-.27.43v21.46a2 2 0 104 0v-2h14.97V3.02a.51.51 0 00-.27-.43zm-4.69 8.95l-4.99 4.99a.742.742 0 01-1.01.04l-2.99-2.49a.78.78 0 01-.27-.51c-.02-.2.04-.39.17-.55a.78.78 0 01.51-.27c.2-.02.39.04.55.17l2.47 2.06 4.5-4.5c.29-.29.77-.28 1.05.01.29.28.29.75.01 1.05z"
  })));
}

export default SvgHighlightBillTick;